import React from 'react'
import JobsList from '../list'
import useCurrentUser from '../../../hooks/use-current-user'
import ReloadButton from '../reload-button'

const JobsDashboard = () => {
    const { isAdmin } = useCurrentUser()
    if (!isAdmin) {
        return null
    }
    return (
        <div style={{ padding: '20px'}}>
            <div
                style={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignContent: 'center',
                }}
            >
                <h1>Jobs</h1>
                <ReloadButton />
            </div>
            
            <JobsList />
        </div>
    )
}

export default JobsDashboard